@import '../../global-styles/index.scss';
@import '../../respond-to.scss';

.ghf {
  &-localStore {
    display: flex;
    position: relative;
    gap: 4px;
    padding: $spacing-8 0;
    text-decoration: none;
    color: $color-shade-white;
    white-space: nowrap;
    a, a:link, a:visited, a:hover {
      color: $color-shade-white;
    };
    &--desktop {
      display: none;
      margin-right: 0;
    }
    &--mobile {
      &:link, &:visited, &:hover {
        color: $color-shade-white;
      }
    }

    @include breakpoint('lg') {
      &--desktop {
        display: flex;
      }

      &--mobile {
        display: none;
      }
    }

    @include breakpoint('xl') {
      &--desktop {
        display: flex;
      }

      &--mobile {
        display: none;
      }
    }

    &:hover {
      .ghf-localStore-tooltip {
        display: block;
      }
    }

    &-tooltip {
      display: none;
      text-align: left;
      text-transform: none;
      background: white;
      position: absolute;
      z-index: 980;
      top: 80%;
      left: 50%;
      min-width: 230px;
      font-size: 14px;
      margin-top: 0.25rem;
      padding: 10px;
      border: 1px solid #ededed;
      box-shadow: 2px 0 2px rgba(0, 0, 0, 0.05);
      transform: translate(-50%);
      color: #615f5f;

      &:hover {
        display: block;
      }

      &::before {
        content: '';
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid white;
        position: absolute;
        top: 0;
        left: 50%;
        margin-top: -5px;
        margin-left: -5px;
      }

      &::after {
        content: '';
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid #ededed;
        position: absolute;
        top: 0;
        left: 50%;
        z-index: -1;
        margin-top: -7px;
        margin-left: -7px;
      }

      &-address {
        padding: 5px 0;
        display: block;
      }

      &-actions {
        display: flex;
        flex-direction: column;

        a {
          display: block;
          border-top: 1px solid #ededed;
          padding: 5px 0;
          text-decoration: none;
          cursor: pointer;
          color: #1e39d2;
          &:link, &:visited {
            color: #1e39d2;
          }
          &:hover {
            color: #0e1b62;
          }
        }
      }
    }
  }
}
